import create from 'zustand';
import { persist } from 'zustand/middleware';

import { StorageE } from 'declarations/enums/storage';

type SavedLocation = {
  pathName: string;
  search: string;
};

type LocationStoreState = {
  location: SavedLocation;
  setLocation: (location: SavedLocation) => void;
};

const useLocationStore = create<LocationStoreState>()(
  persist(
    set => ({
      location: {
        pathName: '',
        search: '',
      },
      setLocation: (location: SavedLocation): void => set({ location }),
    }),
    {
      name: StorageE.LocationStore,
      getStorage: () => localStorage,
    }
  )
);

export default useLocationStore;
